import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarConnectDialogComponent } from './calendar-connect-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AppMaterialModule } from '../../../../../../../shared/appMaterial/app-material.module';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [CalendarConnectDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    AppMaterialModule,
    MatButtonModule,
    MatRadioModule,
    FormsModule,
  ],
  entryComponents: [CalendarConnectDialogComponent],
})
export class CalendarConnectDialogModule {}
